<template>
    <div class="follow-list">
        <Loading v-if="loadingDone"/>
        <div v-if="!loadingDone"/>
            <div class="empty" v-if="!followList.length">
                <img src="../assets/img/empty.png" alt="">
            </div>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多啦~"
                :error.sync="error"
                error-text="请求失败  点击重新加载"
                @load="onFollowListLoad"
                :offset=100
                :immediate-check="false"
                v-if="followList.length"
            >   
				<div class="empty" v-if="followList.length==0"><img src="../assets/img/empty.png" alt=""></div>
                <van-swipe-cell v-for="(item,index) in followList" :key="index">
                    <div class="msg-content-box">
                        <div class="msg-icon" v-if="item&&item.cdkey">
                        </div>
                        <router-link :to="{name:'scriptdetail',query:{id:item&&item.id}}">
                            <div class="msg-content">
                                <div class="title-time">
                                    <div class="title">{{item&&item.title}}</div>
                                    <div class="time" :style="item&&item.over.value==1?'background:#bf0000':'background:#282828'">{{item&&item.over.name}}</div>
                                </div>
                                <div class="content">{{item&&item.intro}}</div>
                                <div class="author-type">
                                    <div class="author">{{item&&item.writer_type==1?'编剧':'策划'}}：{{item&&item.writer_name}}</div>
                                    <div class="type">{{item&&item.one_cateid_name}}·{{item&&item.two_cateid_name.join('·')}}</div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <van-button
                        slot="right"
                        square
                        text="取消关注"
                        type="default"
                        class="delete-button"
                        @click="cancelFollow"
                        :data-role="item&&item.id"
                    />
                </van-swipe-cell>
            </van-list>
        </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
export default {
    name:'FollowList',
    data(){
        return{
            followList:[],                   //储存我的关注列表
            loading: false,                  //控制上划加载状态显示
            finished: false,                 //控制上划加载完成状态显示
            error: false,                    //控制上划加载出错状态显示
            followListPageNum:0,             //获取评论的页码
			loadingDone:true,                //加载页面显示
			followCount:''                   //关注剧本的总数量
        }
    },
    created(){
		//获取我的关注数据
        Axios.get('/user/follow',{params:{page:this.followListPageNum,num:10}})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.followList=response.data.data.lists
					this.followCount=response.data.data.all_count
                    this.loadingDone=false
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    methods:{
        //取消关注(取消关注时滚动请求更多数据，不然删除节点之后没有滚动条无法滑动屏幕加载更多)
        cancelFollow(e){
            Axios.get('article/unfollow/'+e.target.dataset.role)
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        //取消成功后删除当前节点
                        e.target.parentNode.parentNode.remove()
                        //加载下一页数据
                        if(this.finished!==true&&this.followCount>10){
                            this.onFollowListLoad()
                        }
                        
                    }
                }
            ).catch(
                error=>{
                    console.log(error)
                }
            )
        },
        //向下滑屏时加载更多
        onFollowListLoad(){
            this.followListPageNum++
            Axios.get('/user/follow',{params:{page:this.followListPageNum,num:10}})
            .then(
                response=>{
                    if(response.data.data.lists.length==0){
                        this.finished=true
                        return
                    }
                    this.followList.push(...response.data.data.lists)
                    this.loading=false
                }
            ).catch(
                error=>{
                    this.loading = false
                    this.error=true
                    console.log(error)
                }
            )
        }
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
	.empty{
		background:#fff;
		height:280px;
		padding-top:200px;
		img{
			width:280px;
			height:280px;
			display:block;
			margin:0 auto;
		}
	}
    .follow-list{
        width:750px;
        padding-top:88px;
        background:#F8F6F9;
    }
    .empty{
        height:280px;
        width:100%;
        background:#fff;
        padding-top:300px;
        img{
            width:280px;
            height:280px;
            margin:0 auto;
            display:block;
        }
    }
    .msg-content-box{
        padding:40px;
        background:#fff;
        position:relative;
        margin-bottom:10px;
        .msg-icon{
            width:76px;
            height:80px;
            background:url('../assets/img/exchange.png') no-repeat;
            background-size:cover;
            position:absolute;
            left:0;
            top:0;
        }
        .msg-content{
            width:660px;
            .title-time{
                height:32px;
                margin-bottom:26px;
                .title{
                    font-size:26px;
                    color:#333;
                    float:left;
                    font-weight:bold;
                }
                .time{
                    font-size:20px;
                    color:#f7f7f7;
                    float:right;
                    height:30px;
                    width:76px;
                    text-align:center;
                    line-height:30px;
                    background:#282828;
                }
            }
            .content{
                font-size:24px;
                color:#999;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:3;
                overflow:hidden;
                text-overflow:ellipsis;
                line-height:38px;
                margin-bottom:38px;
            }
            .author-type{
                overflow:hidden;
                .author,.type{
                    font-size:24px;
                    color:#999;
                }
                .author{
                    float:left;
                }
                .type{
                    float:right;
                }
            }
        }
    }
    .van-swipe-cell__right{
        button{
            height:100%;
            width:60px;
            padding-left:10px;
            padding-right:10px;
            text-align:center;
            background:#E7E7E7;
            font-size:24px;
            color:#999;
            word-break: break-all;
        }
    }
</style>